import styled from 'styled-components'

export const Row = styled.div`
  display: flex;
  flex-direction: column;
  border-bottom: ${props => props.theme.stroke.default} solid ${props => props.theme.colors.border.subtle};
`

export const ToggleButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${props => props.theme.spacing.sp16};
  width: 100%;
  padding: ${props => props.theme.spacing.sp12} ${props => props.theme.spacing.sp16};
  border: none;
  background-color: transparent;
  text-align: left;
  cursor: pointer;

  svg {
    opacity: 0;
    transition: opacity 0.2s;
  }

  &:hover svg,
  &[aria-expanded='true'] svg {
    opacity: 1;
  }
`

export const Count = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
`
